import suffixList from './suffix-list.json';

const forbiddenBaseDomains = ['gmail', 'yahoo', 'hotmail', 'outlook', 'icloud', 'msn', 'aol'];

export const validateDomain = (email: string, shouldValidate: boolean = false): boolean => {
  if (!email) {
    return false;
  }

  if (!shouldValidate) {
    return true;
  }

  const emailDomain = email.split('@')[1];
  const baseDomain = emailDomain.split('.')[0];
  const suffix = emailDomain.split('.')[1];
  
  if (forbiddenBaseDomains.includes(baseDomain)) {
    return false;
  }

  return suffixList.includes(suffix);
};
